import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { apiConstant } from '../app.constant';
import { HttpClient } from '@angular/common/http';
import { Invoices, SendInvoices } from '../app.model';



@Injectable({
  providedIn: 'root'
})
export class InvoicesService {

  public baseUrl = `${environment.baseUrl}`;
  constructor(private http: HttpClient) { }

  getInvoices(page: number, filters: any = []) {
    let apiUrl = this.baseUrl + apiConstant.INVOICES + '?page=' + page;
    if (filters.active != undefined) {
      apiUrl += '&filters[active]=' + filters.active;
    }

    return this.http.get<Invoices>(apiUrl);
  }

  sendInvoices(ids: string[], payload: any) {
    let apiUrl = this.baseUrl + apiConstant.SEND_INVOICES;

    return this.http.post<SendInvoices>(apiUrl, {
      ids,
      ...payload
    })
  }

  updateInvoice(invoiceId: any, payload: any) {
    let apiUrl = this.baseUrl + invoiceId + '/' + apiConstant.INVOICES;

    return this.http.put<Invoices>(apiUrl, payload)
  }

  downloadInvoice(invoiceId: string, invoiceType: string) {
    let apiUrl = this.baseUrl + invoiceId + '/' + invoiceType + '/' + apiConstant.DOWNLOAD_INVOICE;

    return this.http.post<Invoices>(apiUrl, {});

  }
}
